import { Directive, OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef, NgZone, Inject } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { IntersectionObserverService, IntersectionTarget } from './intersection-observer.service';

export interface IntersectionState {
  isVisible: boolean;
  ratio: number;
}
@Directive({
    selector: '[onScrollView]',
    standalone: true
})
export class OnScrollViewDirective implements OnInit, OnDestroy, IntersectionTarget {

  constructor(
    public elRef: ElementRef,
    @Inject('OnScrollViewIOS') private intersectionObserverService: IntersectionObserverService,
    private zone: NgZone,
    private platform: Platform
  ) { }

  // /** Emits at the end of the animation */
  @Output() viewStateChange = new EventEmitter<IntersectionState>();

  /** When true, triggers the animation on element scrolling in the viewport */
  @Input('once') set detectOnce(value: boolean) { this.once = coerceBooleanProperty(value); }
  public once = false;

  /** Specifies the amout of visibility triggering AOS */
  @Input() threshold = 0.2;

  ngOnInit(): void {
    // Triggers the animation based on the input flags
    if (this.platform.isBrowser) {
      // Attached this directive the LazyViewport so that we can be alerted to changes
      // in this element's visibility on the page.
      this.intersectionObserverService.addTarget(this);
    }
  }

  ngOnDestroy(): void {
    if (this.platform.isBrowser) {
      // If we haven't detached from the LazyViewport, do so now.
      this.intersectionObserverService.removeTarget(this.elRef);
    }

  }

  public updateVisibility(isVisible: boolean, ratio: number): void {
    if (isVisible && this.once) {
      this.intersectionObserverService.removeTarget(this.elRef);
    }
    this.zone.run(() => {
      this.viewStateChange.emit({
        isVisible: isVisible,
        ratio: ratio
      });
    });

  }
}
